const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const CreditTicketList = () => import(/* webpackChunkName: "credit" */ './view/index.vue');
const CreditTicketAdd = () => import(/* webpackChunkName: "credit" */ './view/add.vue');
const CreditTicketEdit = () => import(/* webpackChunkName: "credit" */ './view/edit.vue');

export const ROUTE_NAME_CREDIT = {
    TICKET: {
        INDEX: 'CreditTicketList',
        ADD: 'CreditTicketAdd',
        EDIT: 'CreditTicketEdit'
    }
} as const;

export default [
    {
        path: '/app/:appId/credit/ticket',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_CREDIT.TICKET.INDEX,
                component: CreditTicketList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_CREDIT.TICKET.ADD,
                component: CreditTicketAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/edit',
                name: ROUTE_NAME_CREDIT.TICKET.EDIT,
                component: CreditTicketEdit,
                meta: { requiresAuth: true }
            }
        ]
    }
];
